import { AvailablePlan } from 'src/pricing/types';

import { formatPrice } from './format-price';

export const calculateAnnualPrice = (plan?: AvailablePlan) =>
  plan ? formatPrice(Number(plan.annual.price) / 12) : '';
